<template>
    <section>
        <div id="inicio">
            <h1>BANCO CASOS TOTALES</h1>        
            <div>
                <v-row>
                    <v-col cols="12" md="12" lg="9">
                        <p>
                            "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore 
                            veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia c
                            onsequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci 
                            velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum 
                            exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate 
                            velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?". Ut enim ad minima veniam, quis nostrum 
                            exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate 
                            velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?". Ut enim ad minima veniam, quis nostrum 
                            exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate 
                            velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?". 
                        </p>
                    </v-col>
                    <v-col cols="12" md="12" lg="1" style="background-color: rgb(230, 233, 242); height: 25%; position: fixed; right: 15px;">
                        <h3>Menú</h3>
                        <div>
                            <a href="bancocaso#inicio" style="text-decoration: none;">
                                <p class="p1">Inicio</p>
                            </a>
                            <a href="bancocaso#casos-destacados" style="text-decoration: none;">
                                <p class="p1">Casos Destacados</p>
                            </a>
                            <a href="bancocaso#casos" style="text-decoration: none;">
                                <p class="p1">Casos</p>
                            </a>
                            <a href="bancocaso#estadistica" style="text-decoration: none;">
                                <p class="p1">Estadísticas</p>
                            </a>
                            <router-link to="/casostot" style="text-decoration: none;">
                                <p class="p1">Casos Totales</p>
                            </router-link>
                            <!--
                            <router-link to="/controlsocial" style="text-decoration: none;">
                                <p class="p1">Inicio</p>
                            </router-link>
                            <router-link to="/controlsocial" style="text-decoration: none;">
                                <p class="p1">Casos Destacados</p>
                            </router-link> 
                            <router-link to="/controlsocial" style="text-decoration: none;">
                                <p class="p1">Casos</p>
                            </router-link> 
                            <router-link to="/controlsocial" style="text-decoration: none;">
                                <p class="p1">Estadísticas</p>
                            </router-link>-->
                        </div>
                    </v-col>
                </v-row>                       
            </div>
        </div>
        <div id="casos">
            <h2>CASOS</h2>
            <v-row>
                <v-col cols="12" md="10" lg="3">
                    <v-text-field v-model="search" append-icon="search" label="Buscar por titulo" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="10" lg="3">
                    <v-select v-model="filtroActual" :items="opcionesFiltro" label="Filtrar por Casos Destacados" outlined dense></v-select>
                </v-col>
                <v-col cols="12" md="10" lg="3">
                    <v-select v-model="filtroActual2" :items="opcionesFiltro2" label="Filtrar Tipo de Caso" outlined dense></v-select>
                </v-col>
            </v-row>            
            <v-row>
                <v-col v-for="card in filtered" :key="card.id" cols="12" md="3">
                    <router-link :to="{ name: 'detallecaso', params: { id: card.id } }" style="text-decoration: none;">
                        <v-card class="mx-auto" max-width="380" min-height="180">  <!-- Cara frontal del card con la imagen y el título -->
                            <div v-if="cardState[card.id] && !cardState[card.id].isFlipped">
                                <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                                    <v-carousel-item v-for="(image, index) in card.images" :key="index">
                                        <!-- Ajusta el estilo de v-img para cubrir el espacio del v-card -->
                                        <v-img class="align-end text-white" height="80%" :src="getImageSrc(image)" :style="{ 'object-fit': 'cover' }">
                                            <v-divider class="mx-2 mb-1"></v-divider>
                                        </v-img>
                                        <p style="color: rgb(0, 157, 220); font-size: 16px;">{{ card.title }}</p>
                                    </v-carousel-item>
                                </v-carousel>
                            </div>
                        </v-card>
                    </router-link>
                </v-col>
            </v-row>
        </div>
    </section>
</template>

<script>
//import NoticiaDetalle from './NoticiaDetalle.vue';
//import Publication from './Publication.vue';
//import axios from 'axios';

export default {
    components: {
        //NoticiaDetalle,
        //Publication,
    },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: '',
                r_images: '',
                link: '',
                folder: '',
            },
            cards: [
                {
                    id: 1,
                    title: 'Caso 1',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['logo3.png'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                    component: 'about',
                    destacado: 1,
                    tipo_caso: 1,
                },
                {
                    id: 2,
                    title: 'Caso 2',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 1,
                    tipo_caso: 1,
                },
                {
                    id: 3,
                    title: 'Caso 3',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['logo3.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                    tipo_caso: 1,
                },
                {
                    id: 4,
                    title: 'Caso 4',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['logo3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                    tipo_caso: 2,
                },
                {
                    id: 5,
                    title: 'Caso 5',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                    tipo_caso: 2,
                },
                {
                    id: 6,
                    title: 'Caso 6',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                    tipo_caso: 3,
                },
                {
                    id: 7,
                    title: 'Caso 7',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    destacado: 0,
                    tipo_caso: 4,
                },
            ],
            cardState: {},
            search: '',
            filteredCasos: [],
            filtroActual: null,
            filtroActual2: null,
            opcionesFiltro: [
                { text: 'Todos', value: null },
                { text: 'Destacados', value: 1 },
                { text: 'No destacados', value: 0 }
                // Puedes agregar más opciones de filtro aquí según tus necesidades
            ],
            opcionesFiltro2: [
                { text: 'Todos', value: null },
                { text: 'Deforestación 1', value: 1 },
                { text: 'Deforestación 2', value: 2 },
                { text: 'Deforestación 3', value: 3 },
                { text: 'Deforestación 4', value: 4 },
                { text: 'Deforestación 5', value: 5 }
                // Puedes agregar más opciones de filtro aquí según tus necesidades
            ],
        };  
    },/*
    mounted() {
      this.listar();
    },*/
    computed: {
        filtered() {
            let filteredBySearch = this.cards.filter(caso =>
            caso.title.toLowerCase().includes(this.search.toLowerCase())
            );

            if (this.filtroActual !== null) {
            filteredBySearch = filteredBySearch.filter(caso => caso.destacado === this.filtroActual);
            }

            if (this.filtroActual2 !== null) {
            filteredBySearch = filteredBySearch.filter(caso => caso.tipo_caso === this.filtroActual2);
            }

            return filteredBySearch;
        },
    },
    methods: {
        // Obtener la lista de Categiries
        /*async listar() {
            try {
                const response = await axios.get('api/Categories/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        additionalInfo: category.additionalInfo,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                        link: category.link,
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
    },
    created() {
        // Initialize cardState for each card
        this.cards.forEach(card => {
            this.$set(this.cardState, card.id, { isFlipped: false });
        });
    },
    
};
</script>
<style>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
</style>